<template>
  <div>
    <v-dialog scrollable max-width="fit-content" v-model="model" persistent>
      <material-card
        :title="$t('components.brokersplans.plancreationdialog.create_plan')"
        :color="$vuetify.theme.themes.light.success"
        icon="add"
        v-if="plan !== null && plan !== undefined"
      >
        <v-card-text>
          <v-form v-model="valid">
            <v-container>
              <v-row justify-center>
                <v-col cols="12" sm="6" md="4">
                  <tooltip-textbox
                    :value.sync="plan.UniqueIdentifier"
                    :label="
                      $t('components.plancreationwizard.unique_identifier')
                    "
                    :rules="[
                      $rules.required,
                      $rules.numeric,
                      $rules.dynamic.length(3),
                      rules.unique,
                    ]"
                    class="required"
                    :tooltipText="
                      $t(
                        'components.plancreationwizard.unique_identifier_tooltip'
                      )
                    "
                  ></tooltip-textbox>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <trans-textbox
                    v-model="translations"
                    :label="$t('globals.name')"
                    :rules="[$rules.required]"
                    class="required"
                    field="Name"
                  ></trans-textbox>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <!-- <auto-select
                    :value.sync="plan.PlanType"
                    :items="options.Enums.PlanType"
                    :label="
                      $t('components.brokersplans.plancreationdialog.plan_type')
                    "
                    :rules="[$rules.required]"
                    :slots="true"
                    :filter="filterFunc"
                    class="required"
                    :returnObject="false"
                  >
                    <template v-slot:selection="data">
                      {{ $t("enums." + data.item) }}
                    </template>
                    <template v-slot:item="data">
                      <v-list-item-content
                        v-text="$t('enums.' + data.item)"
                      ></v-list-item-content>
                    </template>
                  </auto-select> -->
                  <trans-enum
                    :value.sync="plan.PlanType"
                    :items="options.Enums.PlanType"
                    :label="
                      $t('components.brokersplans.plancreationdialog.plan_type')
                    "
                    :rules="[$rules.required]"
                    class="required"
                  >
                  </trans-enum>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="$emit('close')" :loading="saving">
            {{ $t("globals.close") }}
          </v-btn>
          <v-btn
            color="primary"
            @click="save"
            :disabled="!valid"
            :loading="saving"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <error-handler :error="error"></error-handler>
    <v-dialog scrollable v-model="successDialog" persistent max-width="500">
      <material-card
        :title="
          $t(
            'components.brokersplans.plancreationdialog.plan_saved_successfully'
          )
        "
        :color="$vuetify.theme.themes.light.success"
        icon="done"
      >
        <v-card-actions>
          <v-btn
            color
            text
            @click="
              successDialog = false;
              $emit('close');
            "
          >
            {{ $t("globals.close") }}
          </v-btn>
          <v-spacer />
          <v-btn color="primary" @click="goToPlan">
            {{ $t("components.brokersplans.plancreationdialog.set_up_plan") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
  </div>
</template>

<script>
import ErrorHandler from "../../components/ErrorHandler.vue";
import AutoSelect from "../AutoSelect.vue";
import TransTextbox from "../TransTextbox.vue";
import TooltipTextbox from "../TooltipTextbox.vue";
import { mapActions, mapGetters } from "vuex";
import TransEnum from "../../components/TransEnum.vue";
export default {
  props: ["model", "broker"],
  components: {
    ErrorHandler,
    AutoSelect,
    TransTextbox,
    TooltipTextbox,
    TransEnum
  },
  data() {
    return {
      error: null,
      plan: null,
      successDialog: false,
      planIdentityId: null,
      valid: false,
      saving: false,
      translations: [],
      uniqueIdentifiers: [],
      rules: {
        unique: (v) =>
          this.uniqueIdentifiers.indexOf(v) === -1 ||
          this.$t("validation.unique_plan"),
      },
    };
  },
  computed: {
    ...mapGetters("plansMembers", ["options"]),
  },
  watch: {
    model: {
      async handler(v) {
        if (v) {
          try {
            this.uniqueIdentifiers = (await this.getPlanUniqueIdentifiers()).data;
            this.plan = {
              BrokerId: this.broker.Id,
              UniqueIdentifier: null,
              // GeneralSettings: {
              //   Broker: this.broker,
              //   BrokerId: this.broker.Id,
              //   Client: {},
              //   UniqueIdentifier: null,
              //   PlanSettings: {
              //     Name: null,
              //     Translations: [],
              //   },
              // },
            };
          } catch (error) {
            this.error = error;
          }
        } else {
          this.plan = null;
        }
      },
    },
  },
  methods: {
    ...mapActions("plansMembers", ["addNewDraft", "getPlanUniqueIdentifiers"]),
    filterFunc(item, search) {
      return (
        this.$t("enums." + item)
          .toLowerCase()
          .indexOf(search.toLowerCase()) > -1
      );
    },
    async save() {
      try {
        this.saving = true;
        this.plan.Translations = this.translations.Translations;
        console.log(this.plan);
        // this.plan.GeneralSettings.Type = "Pension";
        // if (this.plan.GeneralSettings.Type === "HW") {
        //   this.plan.PlanInsuranceCarriers = [];
        //   this.plan.TrustFund = null;
        //   this.plan.Employers = [];
        //   this.plan.Flags = [];
        //   this.plan.MemberDataFields = [];
        //   this.plan.Contacts = [];
        //   this.plan.Coverages = [];
        //   this.plan.ConfigurationParameters = [];
        //   this.plan.CalculationFormulas = [];
        //   this.plan.MemberGroups = [];
        //   this.plan.ReportConfiguration = {
        //     InheritedBrokerAddress: true,
        //     BrokerCity: this.broker.City,
        //     BrokerPostalCode: this.broker.PostalCode,
        //     BrokerProvince: this.broker.Province.Name,
        //     BrokerStreetName: this.broker.StreetName,
        //     BrokerStreetNumber: this.broker.StreetNumber,
        //     BrokerSuiteNumber: this.broker.SuiteNumber,
        //     BrokerLogo: this.broker.BrokerLogo,
        //     ReportConfiguration: {},
        //   };
        //   this.plan.DemographicFields = [];
        //   this.plan.BillingImportFields = [];
        //   this.plan.Eligibility = {
        //     MemberEligibility: {},
        //   };
        //   this.plan.BillingTerm = [];
        //   this.plan.ContributionCategories = [];
        //   this.plan.HoursSetup = {
        //     PrimaryHourImportMemberIdentifier: null,
        //     CandidateHourImportMemberIdentifiers: [],
        //     IncludeContributionAmount: false,
        //   };
        // }
        this.planIdentityId = (await this.addNewDraft({
          planIdentityId: "00000000-0000-0000-0000-000000000000",
          brokerId: this.broker.Id,
          payload: this.plan,
        })).data;
        this.successDialog = true;
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
    goToPlan() {
      this.$router.push({
        name: "planWizardView",
        params: {
          broker: this.broker.Id,
          plan: this.planIdentityId,
          status: "Draft",
        },
      });
    },
  },
};
</script>

<style></style>
